import { Controller, Post, Body, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { RecruitmentActivitiesDTO } from './dto/recruitment-activities.dto';
import { AllRecruitmentActivitiesResponse,  RecruitmentActivitiesResponse } from '@gtpl/shared-models/hrms';
import { RecruitmentActivitiesRequest } from './dto/recruitment-activities.request';
import { RecruitmentActivitiesService } from './recruitment-activities.service';



@ApiTags('recruitment-activities')
@Controller('recruitment-activities')
export class RecruitmentActivitiesController {
    constructor(
        private service: RecruitmentActivitiesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

    @Post('/createRecruitmentActivity')
    async createRecruitmentActivity(@Body() DTO: RecruitmentActivitiesDTO, isUpdate: boolean = false): Promise<RecruitmentActivitiesResponse>{
        try{
            return await this.service.createRecruitmentActivity(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(RecruitmentActivitiesResponse, error);
        }
    }

    @Post('/updateRecruitmentActivity')
    async updateRecruitmentActivity(@Body() DTO: RecruitmentActivitiesDTO, isUpdate: boolean = false): Promise<RecruitmentActivitiesResponse>{
        try{
            return await this.service.createRecruitmentActivity(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(RecruitmentActivitiesResponse, error);
        } 
    }

    @Post('/getAllRecruitmentActivities')
    async getAllRecruitmentActivities(): Promise<AllRecruitmentActivitiesResponse>{
        try{
            return await this.service.getAllRecruitmentActivities();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllRecruitmentActivitiesResponse, error);
        }
    }

    @Post('/getAllActiveRecruitmentActivities')
    async getAllActiveRecruitmentActivities(): Promise<AllRecruitmentActivitiesResponse>{
        try{
            return await this.service.getAllActiveRecruitmentActivities();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllRecruitmentActivitiesResponse, error);
        }
    }

    @Post('/activateOrDeactivateRecruitmentActivity')
    async activateOrDeactivate(@Body() req: RecruitmentActivitiesRequest): Promise<RecruitmentActivitiesResponse>{
        try{
            return await this.service.activateOrDeactivateRecruitmentActivity(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(RecruitmentActivitiesResponse, error)
        }
    }
}
